import {
  ActionCreator,
  ThunkAction,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/root-reducer';

type ServiceWorkerInitialState = {
  newVersionAvailable: boolean;
  waitingWorker: ServiceWorker | null;
};

const initialState: ServiceWorkerInitialState = {
  newVersionAvailable: false,
  waitingWorker: null,
};

const serviceWorkerSlice = createSlice({
  name: 'serviceWorker',
  initialState,
  reducers: {
    serviceWorkerUpdated: (state, { payload }) => {
      state.waitingWorker = payload?.waiting;
      state.newVersionAvailable = true;
    },
    newVersionInstalled: (state) => {
      state.newVersionAvailable = false;
    },
  },
});

const { reducer, actions } = serviceWorkerSlice;

export const { serviceWorkerUpdated } = actions;

export const updateServiceWorker: ActionCreator<ThunkAction<
  void,
  RootState,
  null,
  any
>> = () => (dispatch, getState) => {
  const { waitingWorker } = getState().serviceWorker;

  if (waitingWorker) {
    waitingWorker.postMessage({
      type: 'SKIP_WAITING',
    });
  }

  actions.newVersionInstalled();

  caches.keys().then(async (names) => {
    await Promise.all(names.map((name) => caches.delete(name)));
  });

  window.location.reload(true);
};

// selectors
const serviceWorker = (state: RootState) => state.serviceWorker;

export const selectNewVersionAvailable = createSelector(
  [serviceWorker],
  (service) => service.newVersionAvailable
);

export default reducer;
